// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { DateTypeCode } from "./DateTypeCode";
import {
  DateTypeCodeFromJSON,
  DateTypeCodeFromJSONTyped,
  DateTypeCodeToJSON,
  DateTypeCodeToJSONTyped,
} from "./DateTypeCode";

/**
 *
 * @export
 * @interface ModelDate
 */
export interface ModelDate {
  /**
   * Referentie datum van de dataset.
   */
  date: Date;
  /**
   * Gebeurtenis waar de datum betrekking op heeft.
   */
  type: DateTypeCode;
}

/**
 * Check if a given object implements the ModelDate interface.
 */
export function instanceOfModelDate(value: object): value is ModelDate {
  if (!("date" in value) || value["date"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function ModelDateFromJSON(json: any): ModelDate {
  return ModelDateFromJSONTyped(json, false);
}

export function ModelDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelDate {
  if (json == null) {
    return json;
  }
  return {
    date: json["date"] == null ? json["date"] : parseDate(json["date"]),
    type: DateTypeCodeFromJSON(json["type"]),
  };
}

export function ModelDateToJSON(json: any): ModelDate {
  return ModelDateToJSONTyped(json, false);
}

export function ModelDateToJSONTyped(
  value?: ModelDate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    date: value["date"] == null ? value["date"] : serializeDate(value["date"]),
    type: DateTypeCodeToJSON(value["type"]),
  };
}
